import {createSlice } from '@reduxjs/toolkit'

const AddArticleInARSlice = createSlice({
    name: "AddArticleInARSlice",
    initialState: {
        AddedArticle:{
                id: '',
                idArticle: 0,
                Sum: '',
                Name: '',
                ResponsibleUserName: '',
                OtherExpenditure: false,
                TransactionType: '',
                Type: '',
                Comment: '',
                CreateAdDate: '',
                CreateAdTime: '',
                idCity: ''
            },
        EditAddedArticle: false,
        AddAdminArticle: false,
        AddAdminOtherExpenditure: false
    },
    reducers: {
        addTypeArticleInAR(state, actions){
            state.AddedArticle.Type = actions.payload.Type
            state.AddedArticle.TransactionType = actions.payload.TransactionType
            state.AddedArticle.ResponsibleUserName = actions.payload.User
            state.AddedArticle.id = actions.payload.id

            state.AddedArticle.CreateAdTime = String(new Date().getHours()).padStart(2, '0') + ':' + String(new Date().getMinutes()).padStart(2, '0')

            if((parseFloat(new Date().getMonth()) + 1) === actions.payload.MonthValue && new Date().getFullYear() === actions.payload.YearValue)
                state.AddedArticle.CreateAdDate =  new Date().getFullYear() + '-' + String(parseFloat(new Date().getMonth()) + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
                      
        },
        clearAddedArticle(state){
            state.AddedArticle = {
                id: '',
                idArticle: 0,
                Sum: '',
                Name: '',
                ResponsibleUserName: '',
                OtherExpenditure: false,
                TransactionType: '',
                Type: '',
                Comment: '',
                CreateAdDate: '',
                CreateAdTime: '',
                idCity: ''
            }
            state.EditAddedArticle = false
            state.AddAdminArticle = false
            state.AddAdminOtherExpenditure = false
        },
        selectAddedArticle(state, actions){
            state.AddedArticle.Name = actions.payload.Name
            state.AddedArticle.idArticle = actions.payload.idArticle
            state.AddedArticle.OtherExpenditure = actions.payload.OtherExpenditure
        },
        changeDateAddedArticle(state, actions){
            state.AddedArticle.CreateAdDate = actions.payload
        },
        changeSumAddedArticle(state, actions){
            state.AddedArticle.Sum = actions.payload
        },
        changeCommentAddedArticle(state, actions){
            state.AddedArticle.Comment = actions.payload
        },
        openEditAddedArticle(state, actions){
            state.AddedArticle = {
                id: actions.payload.id,
                idArticle: actions.payload.idArticle,
                Sum: actions.payload.Sum,
                Name: actions.payload.Name,
                ResponsibleUserName: actions.payload.ResponsibleUserName,
                OtherExpenditure: actions.payload.OtherExpenditure,
                TransactionType: actions.payload.TransactionType,
                Type: actions.payload.Type,
                Comment: actions.payload.Comment,
                CreateAdDate: actions.payload.CreateAdDate,
                CreateAdTime: actions.payload.CreateAdTime,
                idCity: actions.payload.idCity
            }
            state.EditAddedArticle = true
            state.AddAdminArticle = actions.payload.AddAdminArticle
            state.AddAdminOtherExpenditure = actions.payload.AddAdminOtherExpenditure
        },
        openAddedAdminArticle(state, actions){
            if(!actions.payload.OtherExpenditure)
            {
                state.AddedArticle = {
                    idArticle: actions.payload.idArticle,
                    Name: actions.payload.Name,
                    ResponsibleUserName: actions.payload.ResponsibleUserName,
                    OtherExpenditure: actions.payload.OtherExpenditure,
                    TransactionType: actions.payload.TransactionType,
                    Type: actions.payload.Type,
                    CreateAdDate: actions.payload.CreateAdDate,
                    CreateAdTime: actions.payload.CreateAdTime,
                    idCity: actions.payload.idCity
                }
                state.AddAdminArticle = true
            }
            
            if(actions.payload.OtherExpenditure)
            {
                state.AddedArticle = {
                    ResponsibleUserName: actions.payload.ResponsibleUserName,
                    OtherExpenditure: actions.payload.OtherExpenditure,
                    TransactionType: actions.payload.TransactionType,
                    Type: actions.payload.Type,
                    CreateAdDate: actions.payload.CreateAdDate,
                    CreateAdTime: actions.payload.CreateAdTime,
                    idCity: actions.payload.idCity
                }
                state.AddAdminOtherExpenditure = true
            }
            
        }
    }
})

export default AddArticleInARSlice.reducer
export const { 
    addTypeArticleInAR, 
    clearAddedArticle, 
    selectAddedArticle, 
    changeDateAddedArticle, 
    changeSumAddedArticle, 
    changeCommentAddedArticle, 
    openEditAddedArticle,
    openAddedAdminArticle 
} = AddArticleInARSlice.actions